export default function Seen(seen: boolean) {
  const statusClass = () => {
    if (!seen)
      return "rounded-2xl bg-orange-400 text-white w-24 text-center capitalize";
    return "rounded-2xl bg-green-400 text-white w-24 text-center capitalize";
  };

  return (
    <p
      style={{ paddingBottom: "2px", fontSize: "13px" }}
      className={statusClass()}
    >
      {seen ? "Seen" : "Pending"}
    </p>
  );
}
